//@flow
import {
  select,
  call,
  put,
  takeLatest,
  takeEvery,
  fork,
  all,
  take,
  actionChannel
} from "redux-saga/effects";
import { eventChannel } from "redux-saga";

import socket from "../socket.js";
import { STATS_UPDATE } from "../stats/constants.js";
import { POLL_RECEIVED } from "../poll/constants";

// wrapping function for socket.on
const connect = () => {
  return new Promise(resolve => {
    socket.on("connect", () => {
      resolve(socket);
    });
  });
};

const createSocketChannel = channel => {
  return socket =>
    eventChannel(emit => {
      const handler = data => {
        emit(data);
      };
      socket.on(channel, handler);
      return () => {
        socket.off(channel, handler);
      };
    });
};

const createStatsSocketChannel = createSocketChannel("onboardingStatsEvent");
const createUserSocketChannel = createSocketChannel("userEvent");
const createPollSocketChannel = createSocketChannel("poll");

const listenStatsEvent = function*(newSocket) {
  const socketChannel = yield call(createStatsSocketChannel, newSocket);

  // then put the new data into the reducer
  while (true) {
    const payload = yield take(socketChannel);
    yield put({ type: STATS_UPDATE, payload: payload.onboardingFeedbackStats });
  }
};

const listenUserEvent = function*(newSocket) {
  // then create a socket channel
  const socketChannel = yield call(createUserSocketChannel, newSocket);

  // then put the new data into the reducer
  while (true) {
    const payload = yield take(socketChannel);
    // if user is forbidden log him out
  }
};

const listenPollEvent = function*(newSocket) {
  const socketChannel = yield call(createPollSocketChannel, newSocket);

  while (true) {
    const payload = yield take(socketChannel);
    yield put({ type: POLL_RECEIVED, payload });
    // if user is forbidden log him out
  }
};

const channelFlow = function*() {
  // connect to the server
  const newSocket = yield call(connect);
  yield fork(listenStatsEvent, newSocket);
  yield fork(listenUserEvent, newSocket);
  yield fork(listenPollEvent, newSocket);
};

function* trackWatcher() {
  yield all([channelFlow()]);
}

export default trackWatcher;
